export default "__VITE_ASSET__DKTnpe3G__"